<script setup>
const props = defineProps({
  size: {
    type: [Number, String],
    default: 18,
  },
  rounded: {
    type: Boolean,
    default: true,
  },
});

const iconSize =
  typeof props.size === 'number' ? `${props.size}px` : props.size;

const lightIconSrc = '/dashboard/images/integrations/woocommerce.svg';
const darkIconSrc = '/dashboard/images/integrations/woocommerce-dark.svg';
</script>

<template>
  <span
    class="inline-flex items-center justify-center overflow-hidden"
    :class="rounded ? 'rounded-[4px]' : ''"
    :style="{ width: iconSize, height: iconSize }"
  >
    <img
      :src="lightIconSrc"
      alt="WooCommerce"
      class="block h-full w-full dark:hidden"
    />
    <img
      :src="darkIconSrc"
      alt="WooCommerce"
      class="hidden h-full w-full dark:block"
    />
  </span>
</template>
